<template>
  <SvgBase iconName="IconWeightMeasurement" width="14" height="14">
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M 2 1 h 10 a 1 1 0 0 1 1 1 v 10 a 1 1 0 0 1 -1 1 H 2 a 1 1 0 0 1 -1 -1 V 2 a 1 1 0 0 1 1 -1 z M 7 4 a 2 2 0 1 0 4 0 a 2 2 0 1 0 -4 0 z M 9 3 v 2 M 8 6 l 1 -1 l 1 1"
        :stroke="color"
        stroke-width="1.05"
        stroke-miterlimit="10"
      />
    </svg>
  </SvgBase>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import SvgBase from '../SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
})
export default class IconWeightMeasurement extends Vue {
  @Prop({ default: 'currentColor' }) readonly color!: string
}
</script>
